module.exports = __webpack_public_path__ + "static/media/mobileLoginBg.2f96c4ce.png";